import { z } from 'zod/v4';

import { blockSchema } from './block.schema';

export const instructionResponseSchema = z.object({
  id: z.number(),
  accountId: z.number().nullable(),
  assetId: z.string().nullable(),
  deviceId: z.string().nullable(),
  vehicleGroupIds: z.array(z.number()).nullable(),
  partnerId: z.string().nullable(),
  blocks: z.array(blockSchema),
  timestamp: z.string(),
  deleted: z.boolean(),
});

export type InstructionResponse = z.infer<typeof instructionResponseSchema>;
